
import React, {FC} from 'react';
import classNames from 'classnames';
import Button from 'components/Button';
import DynamicAsset from 'components/DynamicAsset';
import {Section as Query} from 'templates/reports/query';
import {Section as Config} from 'templates/reports/types';

import {onScrollTo} from '.';

import * as styles from 'templates/reports/Summary/InfoCard/styles.module.scss';

const compact = 'https://static.bodyspec.com/at/34/79/3479e0bede8a616d';

type RegionalCardProps = {
	card?: Config['details']['card']
	data?: Query
}

export const RegionalCard: FC<RegionalCardProps> = ({card, data}) => {
	if (!card || !data || !data.results.length) return null;
	return (
		<div className={styles.wrapper}>
			<div className={classNames(styles.top, styles.image)}>
				<Button variant='underline' onClick={onScrollTo(data.metric)}>
					<div className={styles.title}>
						{card.title}
					</div>
				</Button>
				<div className={styles.content}>
					<div onClick={onScrollTo(data.metric)}>
						<DynamicAsset
							className={styles.compact}
							imageSrc={compact}
						/>
					</div>
					<span>Arms vs Trunk vs Legs</span>
				</div>
			</div>
		</div>
	);
};
